import { Outlet } from 'react-router';

import { SettingsNav } from './SettingsNav';
import { SettingsRouteActions } from './SettingsRouteActions';
import { HeaderToolbarAndContentLayout } from 'src/common/primitives/HeaderToolbarAndContentLayout';

export function SettingsLayout() {
  return (
    <HeaderToolbarAndContentLayout
      actionSection={<SettingsRouteActions />}
      preContent={<SettingsNav />}
      content={<Outlet />}
    />
  );
}
